import React from 'react';
import { FaMoneyBillWave, FaCreditCard, FaMobileAlt, FaDollarSign } from 'react-icons/fa';

const PaymentMethodSelector = ({
  value,
  onChange,
  onSplitClick,
  showSplit = true,
  disabled = false
}) => {
  const paymentMethods = [
    { value: 'cash', label: 'Naqd pul', icon: FaMoneyBillWave, color: '#28a745' },
    { value: 'terminal', label: 'Terminal', icon: FaCreditCard, color: '#007bff' },
    { value: 'card', label: 'P2P', icon: FaMobileAlt, color: '#17a2b8' }
  ];

  const handleMethodClick = (methodValue) => {
    if (!disabled && onChange) {
      onChange({ target: { value: methodValue } });
    }
  };

  return (
    <div className="d-flex align-items-center gap-2 flex-wrap">
      {paymentMethods.map((method) => {
        const Icon = method.icon;
        const isSelected = value === method.value;
        return (
          <div
            key={method.value}
            onClick={() => handleMethodClick(method.value)}
            className={`rounded-3 border d-flex flex-column align-items-center justify-content-center cursor-pointer transition-all ${isSelected
                ? 'border-primary shadow-sm'
                : 'border-secondary bg-light'
              }`}
            style={{
              minWidth: '60px',
              minHeight: '50px',
              cursor: disabled ? 'not-allowed' : 'pointer',
              opacity: disabled ? 0.6 : 1,
              backgroundColor: isSelected ? '#f0f8ff' : '#f8f9fa',
              transition: 'all 0.2s ease',
              padding: '8px'
            }}
            onMouseEnter={(e) => {
              if (!disabled && !isSelected) {
                e.currentTarget.style.backgroundColor = '#e9ecef';
              }
            }}
            onMouseLeave={(e) => {
              if (!disabled) {
                e.currentTarget.style.backgroundColor = isSelected ? '#f0f8ff' : '#f8f9fa';
              }
            }}
          >
            <Icon
              size={18}
              color={isSelected ? method.color : '#6c757d'}
              style={{ marginBottom: '4px' }}
            />
            <span
              className="small fw-semibold text-center"
              style={{
                color: isSelected ? method.color : '#6c757d',
                fontSize: '10px'
              }}
            >
              {method.label}
            </span>
          </div>
        );
      })}
      {showSplit && (
        <button
          onClick={onSplitClick}
          disabled={disabled}
          className="btn btn-outline-primary rounded-3 d-flex flex-column align-items-center justify-content-center"
          style={{
              minWidth: '60px',
              minHeight: '50px',
            borderWidth: '2px',
            borderStyle: 'dashed',
            padding: '8px'
          }}
        >
          <FaDollarSign size={18} style={{ marginBottom: '4px' }} />
          <span className="small fw-semibold" style={{ fontSize: '10px' }}>Gibrid</span>
        </button>
      )}
    </div>
  );
};

export default PaymentMethodSelector;
